import React, { memo, ChangeEvent } from 'react'
import { IShipperRate } from 'apps/rms/types/shipperRates'
import { TextInput } from 'components/atoms'

interface IShipperLaneProps {
  value: RecursivePartial<IShipperRate>
  onChange(change: RecursivePartial<IShipperRate>): void
}

export const ShipperLane = memo<IShipperLaneProps>(({ onChange, value: { shipperLaneId } }) => {
  const updateShipperHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    onChange({
      shipperLaneId: value,
    })
  }

  return (
    <div className='col-md-4 col-xs-4'>
      <TextInput
        label='Lane ID'
        placeholder="Enter the shipper's lane ID"
        value={shipperLaneId || ''}
        onChange={updateShipperHandler}
        type='text'
        id='shipper-rates-shipper-lane-id'
        dataTest='modal-shipper-lane-id'
      />
    </div>
  )
})
